import { Avatar, colors, Text } from 'common-components';
import { TSegmentDefType } from '@definitions';
import { useAppTranslation } from '@hooks';
import { StateTagSegment } from '@views/segment/shared';

const TOTAL_STEPS = 3;

type HeaderPropsType = {
  type: TSegmentDefType
  name: string
};
export const HeaderSegment = function ({ type, name }: HeaderPropsType) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
      <Avatar size="lg" />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Text color={colors.gray900} size="lg" style={{ fontWeight: 500 }}>
          {name}
        </Text>
        <StateTagSegment
          state={type}
          style={{ fontSize: 14, lineHeight: '20px', padding: '2px 10px 2px 8px' }}
        />
      </div>
    </div>
  );
};

type StepHeadingPropsType = {
  step: number
  title: string
};
export const StepHeading = ({ step, title }: StepHeadingPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Text color={colors.gray400} size="md" style={{ fontWeight: 500 }}>
        {step} {translate('createSegment.outOf')} {TOTAL_STEPS}
      </Text>
      <Text color={colors.gray900} size="lg" style={{ fontWeight: 500 }}>
        {title}
      </Text>
    </div>
  );
};
